var _style, _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVegaitLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1356.3 332.8",
    style: {
      enableBackground: "new 0 0 1356.3 332.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2,16.2V6.8h40.9l67,197c0.9,2.7,1.8,3.6,4.5,3.6s3.6-0.9,4.5-3.6l67-197H225v9.4l-78.3,224.9H78.3L0,16.2L0.2,16.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.1,166.9c-6.8,35.5-37.3,81-111.6,81s-118.8-47.2-118.8-123.7S290.6,0.5,362.6,0.5S474.2,47.7,474.2,113v22.5H285 c2.7,52.6,35.1,77.4,78.5,77.4s62.8-19.3,69.3-45.9h42.3V166.9z M286.1,101.7h147.6c-1.8-43.2-28.3-66.1-71.1-66.1 C323.9,35.6,292.9,57.6,286.1,101.7L286.1,101.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M561.4,248.4c4.7,29.2,29.2,48.6,72.4,48.6s76.9-28.8,76.9-78.7v-16.2c0-1.8-0.9-2.7-2.7-2.7s-2.7,0.5-4,2.2 C686,225,659.5,234,627.5,234c-58.9,0-112.9-40.5-112.9-117S568.6,0,627.5,0s57.6,9.9,76.9,32.8c3.2,4.1,5,4.9,7.2,4.9 s3.2-1.4,4-4.1l8.5-27h27v209.2c0,74.2-44.1,117-117.9,117s-112.2-35.1-117-84.6h45L561.4,248.4z M634.3,198 c42.7,0,78.7-29.2,78.7-81s-36-81-78.7-81s-78.7,29.2-78.7,81S591.6,198,634.3,198z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M877,104.4l85.5-3.6V88.2c0-33.3-17.1-52.6-58.5-52.6s-58,19.3-58.9,43.6h-41.8c1.8-44.5,33.3-78.7,100.8-78.7 s97.6,34.2,97.6,90v150.7H963v-24.7c0-1.8-0.9-2.7-2.7-2.7s-2.7,0.5-4.5,2.7c-16.6,22.3-41.4,31.5-72,31.5 c-58.5,0-92.2-30.6-92.2-75.6c0-40.5,27-65.5,85.5-67.9L877,104.4z M888.3,212.8c45,0,74.2-25.6,74.2-75.1V135l-85.5,3.6 c-31.5,1.4-45,13.5-45,33.7s20.2,40.5,56.2,40.5H888.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1082.3,31.6 1128.6,31.6 1128.6,142.2 1082.3,142.2 1082.3,167 1201.9,167 1201.9,142.2 1155.6,142.2 1155.6,31.6 1201.9,31.6 1201.9,6.8 1082.3,6.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1356.3,6.8 1229,6.8 1229,31.6 1279.1,31.6 1279.1,167 1306.1,167 1306.1,31.6 1356.3,31.6  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegaitLogoBlack);
export default __webpack_public_path__ + "static/media/vegait-logo-black.80d7ddd411b40e910559866ca3808f1f.svg";
export { ForwardRef as ReactComponent };